export default "__VITE_ASSET__BAi9ldCR__"